import { AbstractPmsApiService } from "./abstract.service";
import { Property } from "../models";

/**
 * @class RecurringPlanPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Property>}
 */
export class RecurringPlanPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/billing/recurring-plan(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {Property}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Property(attributes);
    }

    /**
     * @returns {Promise.<Property[]>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params: params,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/recurring-plan.service.js